'use strict';

import jQuery from 'jquery';
import cookie from './../../vendor/jquery.cookie';

var AlphabeticalList = (function($) {
  return function(options) {

    // Namespace for private variables and functions
    var privateNS = {
      defaults: { // Namespace for default options
      }
    };

    // Namespace for public variables and functions
    var publicNS = {};

    /**
     * Handle user clicks on the A-Z controls for the alphabetical list
     *
     * @param {jQuery.event} $event The triggering event from jQuery
     */
    privateNS.onAlphaFilterClick = function onAlphaFilterClick($event) {

      // Grab the letter that was clicked on and extract the class filter
      // that should be used
      var $target = $(this),
          classFilter = $target.data('filter');

      // Filter the alphabetical listing based on the extracted filter
      privateNS.filterAlphabeticalList(classFilter);
    };

    /**
     * Toggles the active alphabetical control to the one(s) that match the
     * passed in filter and displays the corresponding alphabetical list.
     * Updates the user's filter preference to the passed in filter for
     * restoring their place on future page loads.
     *
     * @param {string} classFilter The filter that the alphabetical list should
     *                             be set to
     */
    privateNS.filterAlphabeticalList = function (classFilter) {

      // Store the selected filter locally for the user.  Notice we don't specify a path, so there can
      // be more than one alpha list.
      $.cookie('alpha_filter', classFilter);

      // Make the letter(s) that correspond to the filter active
      var alphaFilter = privateNS.$container.find('.alphabetical-control.enabled[data-filter="' + classFilter + '"]');

      // If the filter is on the page, select it
      if (alphaFilter.length > 0) {

        // Find the currently active letter and make it inactive
        privateNS.$container.find('.alphabetical-control').removeClass('active');

        // Activate the filter
        alphaFilter.addClass('active');

        // Check if the filter click on was the 'All' option
        if (classFilter === 'filter-by-all') {

          // If All was selected show all of the show
          privateNS.$container.find('.alphabetical-list').removeClass('hide');
        } else {

          // If a non-All filter was selected first check to see if any results
          // are going to be displayed. Next hide all of the show. Finally
          // show either the matching show, or an error message
          var $show = privateNS.$container.find('.alphabetical-list'),
            $filterMatchedShow = $show.filter('.' + classFilter);

          // Hide all of the shows to start
          $show.addClass('hide');

          // Make sure that at least one show will be shown
          if ($filterMatchedShow.length > 0) {

            // There are matches to show so show them
            $filterMatchedShow.removeClass('hide');
          }
        }
      }
    };

    /**
     * Attaches handlers
     */
    privateNS.attachHandlers = function() {

      // When the page loads try to restore the users place in the alphabetical list if they have a preference set
      $(window).on(
        'load',
        privateNS.onPageLoad
      );

      // Attach the A-Z list filter to the A-Z controls
      privateNS.$container.find('.alphabetical-controls').on(
        'click',
        '.alphabetical-control.enabled',
        privateNS.onAlphaFilterClick
      );
    };

    /**
     * Run on page load
     */
    privateNS.onPageLoad = function() {

      // Check to see if there is an alphabetical filter cookie set
      var classFilter = $.cookie('alpha_filter');

      // If there is a class to filter by, request the list to update
      if (classFilter) {

        // Request that the alphabetical list be filtered
        privateNS.filterAlphabeticalList(classFilter);
      }
    };

    /**
     * Construct a new instance
     */
    privateNS.init = function() {

      // Initialize options
      privateNS.options = $.extend({}, privateNS.defaults, options);

      // Create a reference to the UI container
      privateNS.$container = $(privateNS.options.container);

      // Add event handlers to the UI controls
      privateNS.attachHandlers();

      // Return the public namespace
      return publicNS;
    };

    // Return a new instance
    return privateNS.init();
  };
})(jQuery);

export default AlphabeticalList;
